import { render, staticRenderFns } from "./AtlasEditorModal.vue?vue&type=template&id=70a23841&scoped=true&"
import script from "./AtlasEditorModal.vue?vue&type=script&lang=ts&"
export * from "./AtlasEditorModal.vue?vue&type=script&lang=ts&"
import style0 from "./AtlasEditorModal.vue?vue&type=style&index=0&id=70a23841&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a23841",
  null
  
)

export default component.exports